import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { fetchNftBalance } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const FetchBalance = () => {
  // const [balance, setBalance] = useState(null);
  const { account } = useWeb3React();
  const web3 = useWeb3();
  // const contract = taskManagerContract(tokenAddress, web3);

  const contractAddress = Environment?.SmartCityContract;

  const contract = fetchNftBalance(contractAddress, web3);

  const FetchBalanceHook = useCallback(async () => {
    try {
      const balance = await contract.methods.balanceOf(account).call();
      console.log(balance, "ballnceeeeee ress");

      return balance;
    } catch (error) {
      throw error;
    }
  }, [account, web3, contract]);
  return { FetchBalanceHook: FetchBalanceHook };
};
export default FetchBalance;
